<template>
	<v-row
		align="end"
		justify="end"
		align-content="end"
	>
		<template v-if="editMode">
			<v-col class="py-0">
				<v-text-field
					:value="value"
					:placeholder="'Наименование поставщика ' + q"
					dense
					class="body-2"
					:rules="computedRules"
					@input="input"
				></v-text-field>
			</v-col>
		</template>
		<template v-else>
			<v-col
				:class="[
					'subtitle-2 primary--text text-center pa-1',
					grey ? 'text--lighten-4' : ''
				]"
			>
				<v-icon small v-if="selected" color="secondary">check_box</v-icon>
				{{ value }}
			</v-col>
		</template>
	</v-row>
</template>

<script>
	export default {
		props: {
			value: String,
			q: Number,
			type: Number,
			status: Number,
			editMode: Boolean,
			qnsCount: Number,
			grey: Boolean,
			selected: Boolean,
		},
		data: function() {
			return {
				rules: {
					required: v => !!v || 'Обязательное поле',
				},
			}
		},
		computed: {
			computedRules() {
				// console.log('computed rules')
				// console.log('type', this.type)
				// console.log('status', this.status)
				if ((this.type == 1 || this.type == 5) && this.status >= 10
					|| this.type == 2
					|| this.type == 3
					|| this.qnsCount > 1
				) {
					return [ this.rules.required ]
				}
				else {
					return []
				}
			}
		},
		methods: {
			input(e) {
				this.$emit('input', e)
			}
		}
	}
</script>

<style scoped>

</style>
